export enum ConnectionType {
  Operator = 0,
  Supervisor = 1,
  External = 2,
}
